import { BehaviorSubject, Observable, of, throwError } from 'rxjs';

import { Logger } from '@bo-client/core/logger.service';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent
} from '@angular/common/http';
import { AuthenticationService } from '@bo-client/core/authentication/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { AuthorizationService } from '@bo-client/core/authorization/authorization.service';
import { Router } from '@angular/router';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { InitializationService } from '@bo-client/config/initialization.service';
import { SKIP_ERROR_TOAST, SKIP_FORBIDDEN_TOAST } from '@bo-client/core/http/http-context-tokens';

const log = new Logger('AuthInterceptor');

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  isRefreshingToken = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(
    private authService: AuthenticationService,
    private authorizationService: AuthorizationService,
    private toastR: ToastrService,
    private initia: InitializationService,
    private router: Router,
    public dataShareService: DataShareService
  ) {}

  addToken(req: HttpRequest<any>): HttpRequest<any> {
    if (this.authService.credentials) {
      return req.clone({
        setHeaders: {
          Authorization: 'Bearer ' + this.authService.credentials.token
        }
      });
    } else {
      return req;
    }
  }

  logout() {
    this.authService.logout().subscribe((result) => {
      this.router
        .navigate([this.authorizationService.getLogoutRoute()], {
          replaceUrl: true
        })
        .finally(() => {
          this.dataShareService.logout();
          window.location.reload();
        });
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>
  > {
    // Aufrufer, die ihre Fehler selbst pro Datensatz protokollieren (Massenverarbeitung),
    // können die generischen Toasts unterdrücken. Der 401-Zweig bleibt davon unberührt.
    const skipToast = req.context.get(SKIP_ERROR_TOAST);
    const skipForbiddenToast = skipToast || req.context.get(SKIP_FORBIDDEN_TOAST);

    return next.handle(this.addToken(req)).pipe(
      catchError((error, caught) => {
        console.log(error, caught);
        if (error.status === 401) {
          log.error('logging out...');
          this.logout();
          //  this.authService.logout();
          // this.toastR.warning('Ihre Sitzung ist abgelaufen.');
          return of(error.message);
        }

        if (error.status === 403 && !skipForbiddenToast) {
          if (this.authService.credentials) {
            this.toastR.warning('Sie besitzen nicht die benötigten Berechtigungen für diese Resource.');
          }
        }

        if (error.status === 0 && !skipToast) {
          this.toastR.error('Es gab ein Problem bei der Verbindung mit dem Server.');
        }

        if (error.status === 500 && !skipToast) {
          if (this.authorizationService.hasRole('ROLE_ADMIN')) {
            const errorDetails = error.error?.detail || 'Keine weiteren Informationen verfügbar.';

            this.toastR.warning(errorDetails, 'Ein Fehler ist aufgetreten.');
          } else {
            this.toastR.warning('Ein Fehler ist aufgetreten.');
          }
        }

        return throwError(error);
      }) as any
    );
  }
}
